{
  "name": "alumins",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=ca",
    "start:es": "ng serve",
    "build": "ng build && find dist/ -name index.html -exec sed -i 's|<base href=\"[^\"]*\">|<base href=\"./\">|g' {} +",
    "help": "xliff-simple-merge --help",
    "extract": "ng extract-i18n --output-path src/locale",
    "merge:ca": "xliff-simple-merge -i src/locale/messages.es.xlf -d src/locale/messages.ca.xlf",
    "merge:en": "xliff-simple-merge -i src/locale/messages.es.xlf -d src/locale/messages.en.xlf",
    "translate": "npm run extract && npm run merge:ca && npm run merge:en",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.8.0",
  "dependencies": {
    "@angular/animations": "^21.2.4",
    "@angular/cdk": "^21.2.2",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/material": "^21.2.2",
    "@angular/platform-browser": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@movsesiv/datetime-picker": "^21.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@angular/compiler-cli": "^21.0.0",
    "@angular/localize": "^21.2.4",
    "jsdom": "^27.1.0",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8",
    "xliff-simple-merge": "^1.3.0"
  }
}
